import React from 'react';
import CopyToClipboardLeft from '../../CopyToClipboardLeft';
import { CopyIcon } from '../../../helpers/Icons';

export default ({ property, record }) => {
  const value = record?.params?.[property.name];
  return value ? (
    <CopyToClipboardLeft
      value={value}
      icon={(<span style={{color: '#70bbfd'}}><CopyIcon/></span>)}
    >
      {value}
    </CopyToClipboardLeft>
  ) : '';
};
